import { makeStyles, Text } from "@fluentui/react-components";
import * as React from "react";

export interface TruncatedTextProps
{
    text: string | undefined;
};

const useStyles = makeStyles({
    text: {
      overflow: "hidden",
      width: "100%",
      display: "block",
    }
});

export const TruncatedText: React.FC<TruncatedTextProps> = React.memo(({ text }) => {
    const styles = useStyles();

    return (
        <Text title={text} truncate wrap={false} className={styles.text}>{text}</Text>
    );
});